import { errorValidation, maskList, geoIpLookup } from './utils';

let reviewPhone = $('#review_phone');
let country_code = $('form[name="reviews"]').data('country_code');

if (reviewPhone.length) {
	$(window).on('load', function () {
		let phones_exist = false;
		[reviewPhone].forEach(phoneInput => {
			var phoneValue = phoneInput.val();
			if (phoneValue) {
				phones_exist = true;
				setTimeout(function () {
					phoneInput.val(phoneValue);
				}, 500);
			}
		});

		if (!phones_exist) {
			setTimeout(function () {
				// geoIpLookup(countryCode => {
				// 	[reviewPhone].forEach(phoneInput => {
				// 		phoneInput.intlTelInput('setCountry', countryCode.toLowerCase());
				// 		const maskObj = maskList.find(mask => {
				// 			return (
				// 				mask.cc &&
				// 				typeof mask.cc === 'string' &&
				// 				mask.cc.toLowerCase() === countryCode.toLowerCase()
				// 			);
				// 		});
				// 		if (maskObj) {
				// 			console.log(`Applying mask for ${maskObj.cc}: ${maskObj.mask}`);
				// 			phoneInput.inputmask('remove');
				// 			phoneInput.inputmask({ mask: maskObj.mask });
				// 		}
				// 	});
				// });
			}, 500);
		}
	});
}

/**
 * Init intlTelInput
 */
[reviewPhone].forEach(phoneInput => {
	phoneInput.intlTelInput({
		initialCountry: 'auto', // Automatically detect the country
		placeholderNumberType: 'aggressive',
		utilsScript:
			'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.14/js/utils.js',
		separateDialCode: false,
		allowDropdown: false,
	});

	phoneInput.inputmasks({
		inputmask: {
			definitions: {
				'#': {
					validator: '[0-9]',
					cardinality: 1,
				},
			},
			//clearIncomplete: false,
			showMaskOnHover: false, // Show mask
			autoUnmask: true, // Remove country code when input is empty
		},
		match: /[0-9]/,
		replace: '#',
		list: maskList,
		listKey: 'mask',
		onMaskChange: function (maskObj, completed) {
			if (maskObj) {
				// console.log(`Applying mask for ${maskObj.cc}: ${maskObj.mask}`);
				// let countryCode = Array.isArray(maskObj.cc)
				// 	? maskObj.cc[0].toLowerCase()
				// 	: maskObj.cc.toLowerCase();
				// phoneInput.intlTelInput('setCountry', countryCode);
				phoneInput.intlTelInput('setCountry', country_code.toLowerCase());
			} else {
				console.log(`No mask found, applying default mask`);
				phoneInput.inputmask({ mask: '9999999999' }); // Fallback mask
			}
		},
	});

	// On blur: validate phone number
	phoneInput.focusout(function () {
		if ($.trim(phoneInput.val())) {
			if (phoneInput.intlTelInput('isValidNumber')) {
				console.log('isValidNumber');
			} else {
				phoneInput.addClass('_error');
			}
		}
	});

	// On keydown: reset
	phoneInput.keydown(function () {
		phoneInput.removeClass('_error');
	});
});

/**
 * Add custom validation method
 */
$.validator.addMethod(
	'validateReviewPhone',
	function (value, element) {
		return $(element).intlTelInput('isValidNumber');
	},
	window.translations.phoneInvalid
);

/**
 * Validate forms
 */
(() => {
	// Review
	$("form[name='reviews']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'reviews[name]': {
				required: true,
			},
			'reviews[phone]': {
				required: true,
				validateReviewPhone: true,
			},
			'reviews[email]': {
				required: true,
				email: true,
			},
			'reviews[message]': {
				required: true,
			},
		},
		messages: {
			'reviews[name]': {
				required: window.translations.required,
			},
			'reviews[phone]': {
				required: window.translations.required,
			},
			'reviews[email]': {
				required: window.translations.required,
				email: window.translations.emailInvalid,
			},
			'reviews[message]': {
				required: window.translations.required,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
})();
